var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',_vm._b({staticClass:"d-flex justify-center align-center rounded-lg",class:[_vm.pointerClass],attrs:{"width":"28","height":"28","color":_vm.color,"flat":""}},'v-card',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }